import React, { useMemo } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const ManufacturingQuestion = (props) => {
  const { t } = useTranslation();
  const text = useMemo(() => {
    return {
      title: t("manufacturing.question.title"),
      mainTop: {
        title: t("manufacturing.question.mainTop.title"),
        desc: t("manufacturing.question.mainTop.desc"),
        descli1: t("manufacturing.question.mainTop.descli1"),
        descli2: t("manufacturing.question.mainTop.descli2"),
        descli3: t("manufacturing.question.mainTop.descli3"),
        descli4: t("manufacturing.question.mainTop.descli4"),
        desclast: t("manufacturing.question.mainTop.desclast"),
        bgImg: "https://files.authing.co/authing-website/manu-5-1-s.png",
        bgImgDark: "https://files.authing.co/authing-website/manu-5-1-k.png",
      },
      mainBottom: {
        item1: {
          title1: t("manufacturing.question.mainBottom.item1.title1"),
          title2: t("manufacturing.question.mainBottom.item1.title2"),
          contentli1: t("manufacturing.question.mainBottom.item1.contentli1"),
          contentli2: t("manufacturing.question.mainBottom.item1.contentli2"),
          contentli3: t("manufacturing.question.mainBottom.item1.contentli3"),
          bgImg: "https://files.authing.co/authing-website/manu-5-2-s.png",
          bgImgDark: "https://files.authing.co/authing-website/manu-5-2-k.png",
        },
        item2: {
          title: t("manufacturing.question.mainBottom.item2.title"),
          content: t("manufacturing.question.mainBottom.item2.content"),
          contentli1: t("manufacturing.question.mainBottom.item2.contentli1"),
          contentli2: t("manufacturing.question.mainBottom.item2.contentli2"),
          bgImg: "https://files.authing.co/authing-website/manu-5-3-s.png",
          bgImgDark: "https://files.authing.co/authing-website/manu-5-3-k.png",
        },
      },
      aside: {
        title: t("manufacturing.question.aside.title"),
        desc: t("manufacturing.question.aside.desc"),
        descli1: t("manufacturing.question.aside.descli1"),
        descli2: t("manufacturing.question.aside.descli2"),
        descli3: t("manufacturing.question.aside.descli3"),
        descli4: t("manufacturing.question.aside.descli4"),
        desclast: t("manufacturing.question.aside.desclast"),
        bgImg: "https://files.authing.co/authing-website/manu-5-4-s.png",
        bgImgDark: "https://files.authing.co/authing-website/manu-5-4-k.png",
      },
    };
  }, [t]);
  const mobileText = useMemo(() => {
    return [
      {
        title: text.mainTop.title,
        desc: t("manufacturing.question.mainTop.mobileDesc"),
        bgImg: text.mainTop.bgImg,
        bgImgDark: text.mainTop.bgImgDark,
      },
      {
        title: text.aside.title,
        desc: t("manufacturing.question.aside.mobileDesc"),
        bgImg: text.aside.bgImg,
        bgImgDark: text.aside.bgImgDark,
      },
      {
        title: text.mainBottom.item1.title1 + text.mainBottom.item1.title2,
        desc: t("manufacturing.question.mainBottom.item1.mobileDesc"),
        bgImg: text.mainBottom.item1.bgImg,
        bgImgDark: text.mainBottom.item1.bgImgDark,
      },
      {
        title: text.mainBottom.item2.title,
        desc: t("manufacturing.question.mainBottom.item2.mobileDesc"),
        bgImg: text.mainBottom.item2.bgImg,
        bgImgDark: text.mainBottom.item2.bgImgDark,
      },
    ];
  }, [
    t,
    text.aside.bgImg,
    text.aside.bgImgDark,
    text.aside.title,
    text.mainBottom.item1.bgImg,
    text.mainBottom.item1.bgImgDark,
    text.mainBottom.item1.title1,
    text.mainBottom.item1.title2,
    text.mainBottom.item2.bgImg,
    text.mainBottom.item2.bgImgDark,
    text.mainBottom.item2.title,
    text.mainTop.bgImg,
    text.mainTop.bgImgDark,
    text.mainTop.title,
  ]);
  return (
    <section className="manufacturing-question basic-column">
      <h1 className="manufacturing-title basic-title">{text.title}</h1>
      <div className="">
        <div className="manufacturing-question-content basic-column">
          <div className="manufacturing-question-content-main">
            <div
              className="content-main-top"
              style={{
                backgroundImage: `url(${text.mainTop.bgImg})`,
              }}
            >
              <div
                className="inner"
                style={{
                  background: text.mainTop.bgColor,
                }}
              >
                <div className="dark-img" style={{ height: "100%" }}>
                  <div className="content-main-title line1">
                    {text.mainTop.title}
                  </div>
                  <p className="content-main-desc">{text.mainTop.desc}</p>
                  <ul className="content-main-descul">
                    <li>{text.mainTop.descli1}</li>
                    <li>{text.mainTop.descli2}</li>
                    <li>{text.mainTop.descli3}</li>
                    <li>{text.mainTop.descli4}</li>
                  </ul>
                  <p>{text.mainTop.desclast}</p>
                </div>
              </div>
            </div>
            <div className="content-main-bottom">
              <div
                className="content-main-bottom-1"
                style={{
                  backgroundImage: `url(${text.mainBottom.item1.bgImg})`,
                }}
              >
                <div
                  className="inner"
                  style={{
                    background: text.mainBottom.item1.bgColor,
                  }}
                >
                  <div className="dark-img" style={{ height: "100%" }}>
                    <div className="title line1">
                      {text.mainBottom.item1.title1}
                    </div>
                    {text.mainBottom.item1.title2 && (
                      <div className="title line1">
                        {text.mainBottom.item1.title2}
                      </div>
                    )}

                    <ul className="desc">
                      <li>{text.mainBottom.item1.contentli1}</li>
                      <li>{text.mainBottom.item1.contentli2}</li>
                      <li>{text.mainBottom.item1.contentli3}</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="content-main-bottom-2"
                style={{
                  backgroundImage: `url(${text.mainBottom.item2.bgImg})`,
                }}
              >
                <div
                  className="inner"
                  style={{
                    background: text.mainBottom.item2.bgColor,
                  }}
                >
                  <div className="dark-img" style={{ height: "100%" }}>
                    <div className="title line1">
                      {text.mainBottom.item2.title}
                    </div>
                    <div className="desc">{text.mainBottom.item2.content}</div>
                    <ul>
                      <li>{text.mainBottom.item2.contentli1}</li>
                      <li>{text.mainBottom.item2.contentli2}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="manufacturing-question-content-aside"
            style={{
              backgroundImage: `url(${text.aside.bgImg})`,
            }}
          >
            <div
              className="inner"
              style={{
                background: text.aside.bgColor,
              }}
            >
              <div className="dark-img" style={{ height: "100%" }}>
                <div className="title line1">{text.aside.title}</div>
                <div className="desc">{text.aside.desc}</div>
                <ul>
                  <li>{text.aside.descli1}</li>
                  <li>{text.aside.descli2}</li>
                  <li>{text.aside.descli3}</li>
                  <li>{text.aside.descli4}</li>
                </ul>
                <div className="desc">{text.aside.desclast}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="pad-show mobile-show">
        <div className="manufacturing-question-content-mobile basic-column">
          {mobileText.map((item, itemKey) => {
            return (
              <div
                key={itemKey}
                style={{
                  backgroundImage: `url(${item.bgImg})`,
                }}
                className="item"
              >
                <div
                  className="inner"
                  style={{
                    background: item.bgColor,
                  }}
                >
                  <div className="dark-img" style={{ height: "100%" }}>
                    <div className="title line1">{item.title}</div>
                    <p className="desc">{item.desc}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div> */}
    </section>
  );
};
